import React from 'react';
import { formatPrice } from '../data/catalog';
import type { Vehicle, VehicleBadge } from '../types/catalog';
import { useLanguage } from '../contexts/LanguageContext';
interface VehicleCardProps {
  vehicle: Vehicle;
}

/** Cada badge toma un color de la paleta Porsche: rojo, azul, dorado. */
const badgeStyles: Record<VehicleBadge, string> = {
  'New Arrival': 'border-guards bg-guards text-white',
  Electric: 'border-gentian-bright bg-gentian text-white',
  Certified: 'border-gold bg-canvas/80 text-gold',
  Oferta: 'border-gold bg-gold text-canvas'
};
export function VehicleCard({
  vehicle
}: VehicleCardProps) {
  const {
    t
  } = useLanguage();
  const trims = t.trims as Record<string, string>;
  const segments = t.filters as Record<string, string>;
  const badges = t.badges as Record<string, string>;
  return <article className="group flex h-full flex-col border border-line bg-canvas transition-[transform,border-color,box-shadow] duration-[900ms] ease-[var(--ease-lux)] hover:-translate-y-2.5 hover:scale-[1.025] hover:border-guards hover:shadow-[0_40px_80px_-40px_rgba(213,0,28,0.45)]" data-id="element-295" data-mp="6t6qpz92c9gy">
      <a href="#contacto" className="relative block overflow-hidden bg-surface" data-id="element-296" data-mp="319dgan46iao">
        <img src={vehicle.image} alt={t.card.alt(vehicle.model, vehicle.paint)} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-[1000ms] ease-[var(--ease-lux)] group-hover:scale-[1.08]" data-id="element-297" data-mp="7t19v1sybi8q" />
        {vehicle.badge && <span className={`absolute right-4 top-4 border px-3 py-1 text-[10px] font-medium uppercase tracking-[0.2em] ${badgeStyles[vehicle.badge]}`} data-id="element-298" data-mp="3g81fc3haji1u">
            {badges[vehicle.badge] ?? vehicle.badge}
          </span>}

        <span className="pointer-events-none absolute inset-x-5 bottom-5 flex translate-y-4 justify-center opacity-0 transition-[opacity,transform] delay-150 duration-[800ms] ease-[var(--ease-lux)] group-hover:translate-y-0 group-hover:opacity-100" data-id="element-299" data-mp="10hf4d7ktzwfj">
          <span className="border border-guards bg-guards/90 px-6 py-2.5 text-[11px] uppercase tracking-[0.24em] text-white" data-id="element-300" data-mp="31i3a1n4n2phi">
            {t.card.cta}
          </span>
        </span>
      </a>

      <div className="flex flex-1 flex-col p-6 lg:p-7" data-id="element-301" data-mp="3aj1ichm41j5w">
        <div className="flex items-center justify-between gap-3" data-id="element-302" data-mp="36j0rtylqlhih">
          <p className="text-[10px] uppercase tracking-[0.24em] text-mute" data-id="element-303" data-mp="36gmxxt2smbci">
            {segments[vehicle.segment] ?? vehicle.segment}
          </p>
          <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-mute" data-id="element-304" data-mp="2duv5j7f1bkgj">
            <span className="h-2.5 w-2.5 rounded-full border border-white/25" style={{
            backgroundColor: vehicle.paintHex
          }} aria-hidden="true" data-id="element-305" data-mp="2rlqhisktyhoc" />
            {vehicle.paint}
          </p>
        </div>

        <h3 className="mt-3 text-[20px] font-normal leading-snug tracking-tight text-white" data-id="element-306" data-mp="1z330ppcv9ot2">
          <a href="#contacto" className="link-underline" data-id="element-307" data-mp="1v1hugmuu88ru">
            Porsche {vehicle.model}
          </a>
        </h3>
        <p className="mt-2 text-[13px] font-light text-mute" data-id="element-308" data-mp="1pqdp6zp7cxxs">
          {trims[vehicle.id] ?? vehicle.trim}
        </p>

        <div className="mt-auto flex items-end justify-between gap-4 border-t border-line pt-6" data-id="element-309" data-mp="1b1zp2wj67nkx">
          <div data-id="element-310" data-mp="1g01a3n05pwz1">
            <p className="text-[10px] uppercase tracking-[0.24em] text-mute" data-id="element-311" data-mp="1g1m49bik7dwd">{t.card.from}</p>
            <p className="mt-1.5 text-[15px] font-medium tracking-tight text-white" data-id="element-312" data-mp="23pvklxx079g4">
              {formatPrice(vehicle.basePrice)}
            </p>
          </div>
          <div className="text-right" data-id="element-313" data-mp="1trzbfbnmmokn">
            <p className="text-[10px] uppercase tracking-[0.24em] text-mute" data-id="element-314" data-mp="1tqxni6lii7li">{t.card.lease}</p>
            <p className="mt-1.5 text-[15px] font-medium tracking-tight text-guards-bright" data-id="element-315" data-mp="1yq93vehyvb2k">
              {formatPrice(vehicle.leaseFrom)}
              <span className="text-[11px] font-light text-mute" data-id="element-316" data-mp="iewugfhm7wzy"> {t.card.perMonth}</span>
            </p>
          </div>
        </div>
      </div>
    </article>;
}